<template>
  <div class="box9-page">
    <pageTitle 
      title="不讲正确的废话  每个知识点都落地成可执行的操作" 
      tit="从学习到实战，掌握变现所需的完整技能"
      titleColor="#000"
      titColor="#333"
    />
    <div class="page-content common-animation">
      <div class="top-cont">
        <div class="left-cont">
          <div class="icon-box">
            <img src="../../../assets/topic-page/newMedia2/box9/icon-fire.png" alt="">
            <span>赛道</span>
          </div>
          <ul>
            <li v-for="(item, index) in topList1" :key="item">{{ item }}</li>
          </ul>
        </div>
        <div class="right-cont">
          <div class="icon-box">
            <img src="../../../assets/topic-page/newMedia2/box9/icon-card.png" alt="">
            <span>内容类别</span>
          </div>
          <ul>
            <li v-for="(item, index) in topList2" :key="item">
              <img :src="require(`../../../assets/topic-page/newMedia2/box9/icon-type-${index+1}.png`)" alt="">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="bottom-cont">
        <div class="cont-bg">
          <ul class="cont-left-list">
            <li v-for="(item, index) in list" :key="index + 'left'">
              <span class="text1">{{ item.text1 }}</span>
              <span class="text2">{{ item.text2 }}</span>
              <p>{{ item.stit }}</p>
            </li>
          </ul>
          <div class="theme-name">美妆</div>
          <ul class="cont-right-list">
            <li v-for="(item, index) in list2" :key="index + 'right'">
              <span class="text1">{{ item.text1 }}</span>
              <span class="text2">{{ item.text2 }}</span>
              <p>{{ item.stit }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="prompt-copy">
      <img src="../../../assets/topic-page/newMedia2/box9/pic-text.png" alt="">
    </div>
    <div class="btn" @click="childMethod">免费领取学习路线图</div>
  </div>
</template>

<script>
  import pageTitle from "../../../components/common/pageTitle.vue";
  export default {
    components:{
      pageTitle
    },
    name: '',
    data() {
      return {
        topList1:[
          '美妆', '时尚穿搭', '运动健身', '美食', '母婴亲子', '教育培训', '家具家装', '萌宠', '财经投资', '科技数码', '三农', '珠宝文化',
        ],
        topList2:[
          '真实过程', '搞笑演绎', '有用知识', '扎心故事', '爆品宣销', '采访记录'
        ],
        list: [
          {
            text1: '记录自己化妆的过程',
            text2: '记录自己护肤的过程',
            stit: '真实过程'
          },
          {
            text1: '美妆店剧情',
            text2: '职场美妆剧情',
            stit: '搞笑演绎'
          },
          {
            text1: '不脱妆的10个小技巧',
            text2: '10个化妆冷知识',
            stit: '有用知识'
          }
        ],
        list2: [
          {
            text1: '一次不美丽的美容院经历',
            text2: '因为妆容职场出现的乌龙事件',
            stit: '扎心故事'
          },
          {
            text1: '推荐一款定妆喷雾',
            text2: '面霜推荐',
            stit: '爆品宣销'
          },
          {
            text1: '化妆为什么会脱妆',
            text2: '最近购买最满意的美妆产品',
            stit: '采访记录'
          }
        ]
      }
    },
    methods: {
      childMethod() {
        this.$parent.itcastClick();
      }
    },
  }
</script>

<style lang="scss" scoped>
.box9-page{
  height: 1100px;
  background-image: url(../../../assets/topic-page/newMedia2/box9/box9-bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 80px; 
  box-sizing: border-box; 
  margin-bottom: 200px;
  position: relative;
  .btn{
      width: 247px;
      height: 56px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 56px;
      border-radius: 28px;
      font-weight: bold;
      box-sizing: border-box;
      box-shadow: 0 8px 7px #e2b8db;
      background: url("../../../assets/topic-page/newMedia2/btnbg2.png") no-repeat;
      cursor: pointer;
      margin: 40px auto 0;
      padding-right: 20px;
      &:hover{
        box-shadow: none;
      }
    }
  .page-content{
    width: 1200px;
    margin: 45px auto 0;
    .top-cont{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left-cont{
        display: flex;
        align-items: center;
        
        .icon-box{
          width:  40px;
          img{
            width: 40px;
            height: 40px;
          }
          span{
            display: block;
            text-align: center;
            font-family: PingFang-SC-Medium;
            margin-top: 10px;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 16px;
            letter-spacing: 0px;
            color: #333333;
          }
        }
        ul{
          width: 720px;
          height: 64px;
          display: flex;
          align-items: center;
          flex-wrap:wrap;
          li{
            margin-left: 12px;
            margin-bottom: 6px;
            width: 106px;
            height: 29px;
            background-color: #ffe5f6;
            border: 1px solid #ff3377;
            border-radius: 4px;
            text-align: center;
            line-height: 28px;
            box-sizing: border-box;
            font-family: PingFang-SC-Regular;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #33141f;
          }
        }
      }
      .right-cont{
        display: flex;
        align-items: center;
        .icon-box{
          width:  64px;
          text-align: center;
          img{
            width: 40px;
            height: 40px;
          }
          span{
            display: block;
            text-align: center;
            font-family: PingFang-SC-Medium;
            margin-top: 10px;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 16px;
            letter-spacing: 0px;
            color: #333333;
          }
        }
        ul{
          width: 328px;
          height: 66px;
          background-color: #ffe5f6;
          border-radius: 5px;
          border: solid 1px #ff6699; 
          margin-left: 20px;
          padding: 8px 9px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap:wrap;
          li{
            min-width: 84px;
            height: 19px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img{
              width: 16px;
              height: 16px;
            }
            span{
              line-height: 19px;
              font-family: PingFang-SC-Regular;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #33141f;
            }
            &:nth-of-type(1),
            &:nth-of-type(2),
            &:nth-of-type(3){
              margin-bottom: 13px;
            }
          }
        }
      }
    }
    .bottom-cont{
      margin-top: 66px;
      height: 600px;
      background-color: #ffffff;
      box-shadow: 0px 10px 20px 0px 
        #f6edf0;
      border-radius: 20px;
      padding: 66px 33px 0;
      box-sizing: border-box;
      .cont-bg{
        width: 1135px;
        height: 467px;
        background-image: url(../../../assets/topic-page/newMedia2/box9/pic-box9.png);
        background-size: 100% 100%;
        position: relative;
        ul{
          position: absolute;
          width: 455px;
          li{
            position: absolute;
            width: 455px;
            height: 130px;
            span{
              position: absolute;
              font-family: PingFang-SC-Medium;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 16px;
              letter-spacing: 0px;
              color: #253326;
              &.text1{
                top: 38px;
              }
              &.text2{
                top: 83px;
              }
            }
            p{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              font-family: PingFang-SC-Bold;
              font-size: 18px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 56px;
              letter-spacing: 0px;
              color: #ffffff;
            }
            &:nth-of-type(1){
              top: 0;
            }
            &:nth-of-type(2){
              top: 168px;
            }
            &:nth-of-type(3){
              top: 337px;
            }
          }
          &.cont-left-list{
            left: 0;
            li{
              span{
                right: 216px;
              }
              p{
                right: 40px;
              }
            }
          }
          &.cont-right-list{
            right: 0;
            li{
              span{
                left: 216px;
              }
              p{
                left: 40px;
              }
            }
          }
        }
        .theme-name{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-family: PingFang-SC-Bold;
          font-size: 30px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 66px;
          letter-spacing: 0px;
          color: #ff3377;
        }
      }
    }
  }

  .prompt-copy{
    position: absolute;
    width: 100%;
    height: 200px;
    left: 50%;
    transform: translateX(-50%);
    bottom: -200px;
    background-image: url(../../../assets/topic-page/newMedia2/box9/pic-text-bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 40px;
    box-sizing: border-box;
    text-align: center;
    img{
      width: 1067px;
      height: 138px;
    }
  }
}
</style>